


















































import { Component, Mixins, Prop } from "vue-property-decorator";
import _ from "lodash";
import MyForm from "@/mixins/form";

@Component
export default class extends Mixins(MyForm) {
  @Prop() stadiumId!: number;

  authData: any = {};

  handleSubmit(e: any) {
    //
    e.preventDefault();
    this.$message.warning("未开发");
  }

  async loadDetail() {
    const res = await this.$store.dispatch("stadium/settingDetail", {
      stadium_id: this.stadiumId
    });
    if (res && res.Data && res.Data !== "{}") {
      // console.log(res.Data)
      if (res.Data.profit_mch && _.startsWith(res.Data.profit_mch, "{")) {
        this.authData = JSON.parse(res.Data.profit_mch);
      }
      this.formData = res.Data;
    }
  }

  mounted() {
    this.loadDetail();
  }
}
